import React from "react";

// Drag and Drop
import { useDropzone } from "react-dropzone";

//Component
//--> Alert
import { Info } from "../Alert/Alert";
//--> Button
import Button from "../Button/Button";

export default function DragNDrop(props) {
  const { file, onDrop, handleSubmit, downloadFile } = props;

  //Drop Zone Props
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div className="dragDropContainer">
      <Info
        style={{ marginBottom: 10 }}
        title="Instructions"
        msg="Please write Phone Number with country code (i.e. '+92XXXXXXXXXX') while storing your data in Excel file before upload or drag 'n' drop. If you are not able to write country code in excel then create a custom format in toolbar number section."
      />
      <div
        {...getRootProps()}
        className="dragDrop"
        style={isDragActive ? { background: "#aaa" } : { background: "#ccc" }}
      >
        <input {...getInputProps()} />

        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : file ? (
          <p>File Name: {file.name}</p>
        ) : (
          <div>
            <p>
              Drag 'n' drop your Excel files here, or click to select your Excel
              files
            </p>
            <p style={{ color: "#555", margin: "10px 0px" }}>
              Choose right formatted Excel file. Else download file from bottom
              and store your data in it then upload the same file.
            </p>
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {downloadFile ? (
          <Button
            label="Download Excel Format"
            onClickEvent={downloadFile}
            styleType="secondary"
            width={220}
          />
        ) : null}
        {handleSubmit ? (
          <Button
            label="Confirm"
            onClickEvent={handleSubmit}
            styleType={file ? "primary" : "disabled"}
            width={120}
            disabled={file ? false : true}
          />
        ) : null}
      </div>
    </div>
  );
}
